import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '../views/account/Login.vue'
import Registro from '../views/account/Registro.vue'
import Home from '../views/Home.vue'
import Customers from '../views/customers/Index.vue'
import CustomersList from '../views/customers/List.vue'
import CustomerDetail from '../views/customers/Detail.vue'
import MyData from '../views/MyData.vue'
import StoreFront from '../views/storefront'
import OrdersList from '../views/orders/OrdersList'
import NewOrder from '../views/orders/NewOrder'
import StockInquiry from '../views/StockInquiry'
//import NotFound from '../views/NotFound'

Vue.use(VueRouter)

   const routes = [
   {
      path: '/login',
      alias: '/',
      name: 'Login',
      component: Login
   },
   {
      path: '/registro',
      name: 'Registro',
      component: Registro
   },
   {
      path: '/panel',
      name: 'Home',
      component: Home,
      meta: { 
        requiresAuth: true
      }
   },
   {
      path: '/clientes',
      name: 'Customers',
      component: Customers,
      children: [
         { path: '', component: CustomersList },
         { path: 'detalle', name: 'CustomerDetail', component: CustomerDetail},
      ],
      meta: { 
         requiresAuth: true
      }
   },
   {
      path: '/mis-datos',
      name: 'My-Data',
      component: MyData,
      meta: { 
        requiresAuth: true
      }
   },
   {
      path: '/escaparate',
      name: 'StoreFront',
      component: StoreFront,
      meta: { 
        requiresAuth: true
      }
   },
   {
      path: '/pedidos/listado',
      name: 'OrdersList',
      component: OrdersList,
      meta: { 
        requiresAuth: true
      }
   },
   {
      path: '/pedidos/nuevo',
      name: 'NewOrder',
      component: NewOrder,
      meta: { 
        requiresAuth: true
      }
   },
   {
      path: '/consulta-stock',
      name: 'StockInquiry',
      component: StockInquiry,
      meta: { 
        requiresAuth: true
      }
   },
   //{ 
   //   path: '/404',
   //   component: NotFound
   //},
   //{ 
   //   path: '*',
   //   redirect: '/404'
   //},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
   if(to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
         next()
         return
      }
      next('/login') 
   } else {
      next() 
   }
})

export default router
